import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { clearSessionStorage } from '../../storage/SessionStorage';
import { saveLogin } from '../../redux/slices/LoginSlice';
import { RolesValidator } from '../../validations/RolesValidator';
import { ROLE } from '../../utils/ROLE';
import { DoRender } from '../../utils/DoRender';
import './HeaderStyle.css';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';

const HeaderContainer = () => {
    const { t } = useTranslation('headers');
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);

    const logout = () => {
        dispatch(saveLogin({ roles: [] }));
        clearSessionStorage();
    };

    const handleShow = (state) => {
        setShow(state);
    };

    return (
        <Navbar bg='light' expand='lg' expanded={show}>
            <Container>
                <Navbar.Brand to='/' as={NavLink}>
                    {t('bannerText')}
                </Navbar.Brand>
                <Navbar.Toggle aria-controls='basic-navbar-nav' onClick={() => handleShow(!show)} />
                <Navbar.Collapse id='basic-navbar-nav'>
                    <Nav className='me-auto'>
                        {DoRender(
                            RolesValidator([ROLE.DIETIST]),
                            <Nav.Link to='/menu' as={NavLink} onClick={() => handleShow(false)}>
                                {t('foodMenu')}
                            </Nav.Link>)}
                        <Nav.Link to='/todayMenu' as={NavLink} onClick={() => handleShow(false)}>
                            {t('todayMenu')}
                        </Nav.Link>
                        {DoRender(
                            RolesValidator([ROLE.DIETIST]),
                            <Nav.Link to='/recipe' as={NavLink} onClick={() => handleShow(false)}>
                                {t('recipe')}
                            </Nav.Link>)}
                        {DoRender(
                            RolesValidator([ROLE.DIETIST]),
                            <Nav.Link to='/ProductsPage' as={NavLink} onClick={() => handleShow(false)}>
                                {t('product')}
                            </Nav.Link>)}
                        {DoRender(
                            RolesValidator([ROLE.DIETIST, ROLE.DIRECTOR, ROLE.MANAGER]),
                            <Nav.Link to='/warehouse' as={NavLink} onClick={() => handleShow(false)}>
                                {t('warehouseRecords')}
                            </Nav.Link>)}
                        {DoRender(
                            RolesValidator([ROLE.DIETIST, ROLE.DIRECTOR, ROLE.MANAGER]),
                            <Nav.Link to='/orders' as={NavLink} onClick={() => handleShow(false)}>
                                {t('orders')}
                            </Nav.Link>)}
                        {DoRender(
                            RolesValidator([ROLE.DIETIST, ROLE.DIRECTOR, ROLE.MANAGER]),
                            <Nav.Link to='/history' as={NavLink} onClick={() => handleShow(false)}>
                                {t('history')}
                            </Nav.Link>)}
                        {DoRender(
                            RolesValidator([ROLE.DIRECTOR, ROLE.DIETIST]),
                            <Nav.Link to='/partners' as={NavLink} onClick={() => handleShow(false)}>
                                {t('partners')}
                            </Nav.Link>,
                        )}
                        {DoRender(
                            RolesValidator([ROLE.DIRECTOR]),
                            <Nav.Link to='/employees' as={NavLink} onClick={() => handleShow(false)}>
                                {t('employees')}
                            </Nav.Link>,
                        )}
                        {DoRender(
                            RolesValidator([ROLE.DIETIST, ROLE.MANAGER, ROLE.DIRECTOR]),
                            <NavDropdown title={t('reports.title')}>
                                <NavDropdown.Item to='/consumed-products' as={NavLink}
                                                  onClick={() => handleShow(false)}>
                                    {t('reports.consumedProducts')}
                                </NavDropdown.Item>
                            </NavDropdown>,
                        )}
                        {isMobile
                            ? <>
                                <NavDropdown title={t('languages.languages')}>
                                    <NavDropdown.Item
                                        onClick={() => i18next.changeLanguage('lt')}>
                                        {t('languages.lt')}
                                    </NavDropdown.Item>
                                    <NavDropdown.Item
                                        onClick={() => i18next.changeLanguage('en')}>
                                        {t('languages.en')}
                                    </NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link to='/preferences' as={NavLink} onClick={() => handleShow(false)}>
                                    {t('preferences')}
                                </Nav.Link>
                                <Nav.Link to='/login' as={NavLink} onClick={logout}>
                                    {t('logout')}
                                </Nav.Link>
                            </>
                            : <div className='menu-account'>
                                <NavDropdown title={t('languages.languages')}>
                                    <NavDropdown.Item
                                        onClick={() => i18next.changeLanguage('lt')}>
                                        {t('languages.lt')}
                                    </NavDropdown.Item>
                                    <NavDropdown.Item
                                        onClick={() => i18next.changeLanguage('en')}>
                                        {t('languages.en')}
                                    </NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link to='/preferences' as={NavLink} onClick={() => handleShow(false)}>
                                    {t('preferences')}
                                </Nav.Link>
                                <Nav.Link to='/login' as={NavLink} onClick={logout}>
                                    {t('logout')}
                                </Nav.Link>
                            </div>}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};
export default HeaderContainer;
